import { useState } from "react";

// ユーザー規約情報
export interface TermInfoState {
  term_id: string; // 規約ID
  term_version: number; // 規約バージョン
}

export const useLoginStates = () => {
  const [password, setPassword] = useState("");
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState("");

  // 「パスワードを忘れた方、お困りの方はこちら」モーダル表示フラグ
  const [isShowResetPasswordModal, setIsShowResetPasswordModal] = useState<boolean>(false);

  // 「認証パスコードを送信」メッセージモーダル表示フラグ
  const [isShowCompletMessageModal, setIsShowCompletMessageModal] = useState<boolean>(false);

  // ユーザー規約情報
  const [isTermInfo, setTermInfo] = useState<TermInfoState[]>([]);

  // ログインボタン有効フラグ
  const [isActiveLoginButton, setIsActiveLoginButton] = useState(false);

  return {
    password,
    setPassword,
    errorMessage,
    setErrorMessage,
    isActiveLoginButton,
    setIsActiveLoginButton,
    isShowResetPasswordModal,
    setIsShowResetPasswordModal,
    isShowCompletMessageModal,
    setIsShowCompletMessageModal,
    isTermInfo,
    setTermInfo,
  };
};
